import enumeraciones from '@/../static/js/enumeraciones'

let state = {
  Comun_FechaInicial: moment().format('YYYY-MM-DD'),
  Comun_FechaFinal: moment().format('YYYY-MM-DD'),
  Comun_Consecutivo: "",
  Comun_NumeroExtra: "",
  Comun_Fecha: moment().format('YYYY-MM-DD')
}

let mutations = {
  M_Comun_FechaInicial(state, data) {
    state.Comun_FechaInicial = data;
  },
  M_Comun_FechaFinal(state, data) {    
    state.Comun_FechaFinal = data;
  },
  M_Comun_Consecutivo(state, data) {    
    state.Comun_Consecutivo = data;
  },
  M_Comun_NumeroExtra(state, data) { 
    state.Comun_NumeroExtra = data;
  },
  M_Comun_Fecha(state, data) {
    state.Comun_Fecha = data;
  }
}

let actions = {
  A_Comun_FechaInicial: ({ commit }, data) => {    
    commit('M_Comun_FechaInicial', data);
  },
  A_Comun_FechaFinal: ({ commit }, data) => {
    commit('M_Comun_FechaFinal', data);
  },
  A_Comun_Consecutivo: ({ commit }, data) => {    
    commit('M_Comun_Consecutivo', data);
  },
  A_Comun_NumeroExtra: ({ commit }, data) => {    
    commit('M_Comun_NumeroExtra', data);
  },
  A_Comun_Fecha: ({ commit }, data) => {
    commit('M_Comun_Fecha', data);
  },
  A_Comun_LimpiarStore: ({ commit }, data) => {    
    data.forEach(function (element) {      
      switch (element.componente) {
        case enumeraciones.catalogos.Juzgados:
          commit('M_PJ_Catalogos_001Area', element.parametros);
          break;
        case enumeraciones.catalogos.Materias:
          commit('M_PJ_Catalogos_002Materia', element.parametros);
          break;
        case enumeraciones.catalogos.TiposDeDocumentos:
          commit('M_PJ_Catalogos_004TipoDocumento', element.parametros);
          break;
        case enumeraciones.catalogos.PartidosJudiciales:
          commit('M_PJ_Catalogos_009PartidoJudicial', element.parametros);
          break;
        case enumeraciones.catalogos.Consecutivo:
          commit('M_Comun_Consecutivo', "");
          break;
      }
    });
  },  
}

const Comun = {
  State: state,
  Mutations: mutations,
  Actions: actions
}
export default Comun;



// WEBPACK FOOTER //
// ./src/store/Comun.js